import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';
import { SearchService } from '@sparro/app/core/api/search/search.service';
import { HeaderService } from '@sparro/app/core/api/header/header.service';

@Component({
  selector: 'app-journal-common',
  templateUrl: './journal-common.component.html',
  styleUrls: ['./journal-common.component.scss']
})
export class JournalCommonComponent implements OnInit {
  leftSideNav: boolean = false;
  desktopView: boolean = false;
  tabletView: boolean = false;
  mobileView: boolean = false;

  @ViewChild('leftnav') leftnav: MatDrawer;

  constructor(
    private searchService: SearchService,
    public breakpointObserver: BreakpointObserver,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.headerService.setHeaderWidth('medium');
    this.searchService.setActiveSearchHost('Journals');
    this.initializeBreakpoints();
    this.headerService.getLeftNav().subscribe(res => {this.leftSideNav = res;});
  }

  initializeBreakpoints() {
    this.breakpointObserver.observe([
      BREAKPOINTS.below.md, BREAKPOINTS.below.lg
    ]).subscribe(result => {
      this.mobileView = result.breakpoints[BREAKPOINTS.below.md];
      this.tabletView = result.breakpoints[BREAKPOINTS.below.lg];
    });
  }

  closeBackdrop(): void {
    this.headerService.setLeftNav(false);
    this.leftnav.toggle();
  }
}
